import { render } from "./MainPageEditor.vue?vue&type=template&id=aafc3b80&scoped=true"
import script from "./MainPageEditor.vue?vue&type=script&lang=js"
export * from "./MainPageEditor.vue?vue&type=script&lang=js"

import "./MainPageEditor.vue?vue&type=style&index=0&id=aafc3b80&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aafc3b80"]])

export default __exports__